module.exports = __webpack_public_path__ + "static/media/heavysleet-icon.e9bb7900.svg";